export default "__VITE_ASSET__CzLa7$L6__"